<mat-toolbar class="mat-elevation-z8">
    {{ 'SHUTTLE_CHECKIN.CREATE_BUS_TOUR' | transloco }}
</mat-toolbar>

<mat-dialog-content class="mt-3">

    <div class="my-2">
        <form [formGroup]="createOrderShuttleBusForm">
            <table>
                <tr>
                    <td colspan="2">
                        <mat-form-field appearance="outline">
                            <mat-label>{{ 'SHUTTLE_CHECKIN.ROUTE' | transloco }}</mat-label>
                            <input matInput formControlName="routeCode" placeholder="Rutt">
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <td class="table-cell-width-300">
                        <mat-form-field appearance="outline">
                            <mat-label>{{ 'SHUTTLE_CHECKIN.ROUTE_START_DATE' | transloco }}</mat-label>
                            <input matInput formControlName="startDate" [matDatepicker]="startDate">
                            <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
                            <mat-datepicker #startDate></mat-datepicker>
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field appearance="outline">
                            <mat-label>{{ 'SHUTTLE_CHECKIN.ROUTE_START_TIME' | transloco }}</mat-label>
                            <input matInput type="time" value="{{startTime}}" formControlName="startTime">
                        </mat-form-field>
                    </td>
            </table>
        </form>
    </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="createOrderShuttleBus()">{{'SHUTTLE_CHECKIN.SAVE' |
        transloco}}</button>
    <button mat-button mat-dialog-close>{{'SHUTTLE_CHECKIN.CLOSE' | transloco}}</button>
</mat-dialog-actions>
<p>&nbsp;</p>